import { render, staticRenderFns } from "./ScreenPlaceholderSidebar.vue?vue&type=template&id=241c9d2d&scoped=true"
import script from "./ScreenPlaceholderSidebar.vue?vue&type=script&lang=js"
export * from "./ScreenPlaceholderSidebar.vue?vue&type=script&lang=js"
import style0 from "./ScreenPlaceholderSidebar.vue?vue&type=style&index=0&id=241c9d2d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241c9d2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('241c9d2d')) {
      api.createRecord('241c9d2d', component.options)
    } else {
      api.reload('241c9d2d', component.options)
    }
    module.hot.accept("./ScreenPlaceholderSidebar.vue?vue&type=template&id=241c9d2d&scoped=true", function () {
      api.rerender('241c9d2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/ScreenPlaceholderSidebar.vue"
export default component.exports